import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import { CloudUpload, Psychology, EmojiEvents, ArrowForward } from '@mui/icons-material';
import { servicesColors as colors } from '../theme';
const steps = [
    {
        icon: CloudUpload,
        number: '01',
        title: 'Upload Applications',
        description: 'Batch upload resumes from job boards, emails, or your ATS. We support PDF, DOC, images—even scanned documents from walk-ins.',
        highlight: 'Any format accepted',
    },
    {
        icon: Psychology,
        number: '02',
        title: 'AI Analyzes Skills',
        description: 'Our AI extracts experience, certifications (EPA 608, ASE, NATE), licenses, equipment familiarity, and calculates fit scores instantly.',
        highlight: 'Trade-specific AI',
    },
    {
        icon: EmojiEvents,
        number: '03',
        title: 'Hire Top Talent',
        description: 'Get a ranked shortlist with detailed breakdowns. Focus interviews on candidates who actually have the skills and certs you need.',
        highlight: 'Same-day callbacks',
    },
];
export const HowItWorksSection = () => {
    return (_jsx(Box, { component: "section", sx: {
            py: { xs: 8, md: 12 },
            background: `linear-gradient(180deg, ${colors.background} 0%, #ffffff 100%)`,
        }, children: _jsxs(Container, { maxWidth: "lg", children: [_jsxs(Box, { sx: { textAlign: 'center', mb: 8 }, children: [_jsx(Box, { sx: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 1,
                                px: 2.5,
                                py: 1,
                                backgroundColor: colors.primaryLight,
                                borderRadius: 6,
                                mb: 3,
                            }, children: _jsx(Typography, { sx: {
                                    fontSize: '0.85rem',
                                    fontWeight: 600,
                                    color: colors.primary
                                }, children: "Simple 3-Step Process" }) }), _jsx(Typography, { variant: "h2", sx: {
                                fontWeight: 700,
                                color: colors.text,
                                fontSize: { xs: '1.75rem', md: '2.5rem' },
                                mb: 2
                            }, children: "From Pile to Shortlist in Minutes" }), _jsx(Typography, { sx: {
                                color: colors.textSecondary,
                                fontSize: '1.1rem',
                                maxWidth: 600,
                                mx: 'auto'
                            }, children: "No complicated setup. No lengthy training. Just upload, analyze, and hire." })] }), _jsx(Grid, { container: true, spacing: 3, alignItems: "stretch", children: steps.map((step, index) => (_jsx(Grid, { size: { xs: 12, md: 4 }, children: _jsxs(Card, { elevation: 0, sx: {
                                height: '100%',
                                backgroundColor: '#ffffff',
                                borderRadius: 4,
                                border: '1px solid',
                                borderColor: colors.divider,
                                position: 'relative',
                                overflow: 'visible',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-8px)',
                                    boxShadow: '0 20px 40px rgba(30, 64, 175, 0.12)',
                                    borderColor: colors.primary,
                                },
                            }, children: [_jsx(Box, { sx: {
                                        position: 'absolute',
                                        top: -16,
                                        left: 24,
                                        width: 48,
                                        height: 48,
                                        background: colors.gradient,
                                        borderRadius: 3,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 8px 20px rgba(30, 64, 175, 0.3)',
                                    }, children: _jsx(Typography, { sx: {
                                            color: '#ffffff',
                                            fontWeight: 800,
                                            fontSize: '1.1rem'
                                        }, children: step.number }) }), index < steps.length - 1 && (_jsx(Box, { sx: {
                                        display: { xs: 'none', md: 'flex' },
                                        position: 'absolute',
                                        right: -20,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        zIndex: 10,
                                        width: 40,
                                        height: 40,
                                        borderRadius: '50%',
                                        backgroundColor: '#ffffff',
                                        border: '2px solid',
                                        borderColor: colors.secondary,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }, children: _jsx(ArrowForward, { sx: { color: colors.secondary, fontSize: 20 } }) })), _jsxs(CardContent, { sx: { p: 4, pt: 5 }, children: [_jsx(Box, { sx: {
                                                width: 64,
                                                height: 64,
                                                borderRadius: 3,
                                                backgroundColor: colors.primaryLight,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mb: 3,
                                            }, children: _jsx(step.icon, { sx: { fontSize: 32, color: colors.primary } }) }), _jsx(Typography, { sx: {
                                                fontWeight: 700,
                                                fontSize: '1.25rem',
                                                color: colors.text,
                                                mb: 2
                                            }, children: step.title }), _jsx(Typography, { sx: {
                                                color: colors.textSecondary,
                                                fontSize: '0.95rem',
                                                lineHeight: 1.7,
                                                mb: 3
                                            }, children: step.description }), _jsx(Box, { sx: {
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 0.5,
                                                px: 2,
                                                py: 0.75,
                                                backgroundColor: colors.secondaryLight,
                                                borderRadius: 2,
                                            }, children: _jsx(Typography, { sx: {
                                                    fontSize: '0.8rem',
                                                    fontWeight: 600,
                                                    color: colors.secondary
                                                }, children: step.highlight }) })] })] }) }, index))) })] }) }));
};
